import Table from './Table';
import { columnsOrder, headings } from './constants';

export default function AppCatalog() {
  return <Table headings={headings} source="app-catalog" columnsOrder={columnsOrder} />;
}
